<template>
  <van-collapse v-model="activeName" accordion class="politicalparty">
    <van-collapse-item
      title="为农服务平台-数字庄稼医院"
      name="1"
      class="politicalparty-item"
      :class="{ 'politicalparty-item-check': activeName == '1' }"
    >
      <div class="info">
        农服务平台-“数字庄稼医院”通过构建农资服务、农技服务、农产行销和政策宣传等服务内容，切实以农为本、为农服务、助农增收，同时促进农资公司、专家资源、经营网点的互惠互利。
      </div>
      <img
        :src="product_society_society_xzzjyy"
        alt="数字庄稼医院"
        class="politicalparty-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div class="text">
          多方价值共振：以“利他”思维，把“服务”嵌在“互惠”之前，通过平台将三者有机的联动运作起来，盘活了区域要素的互通流动、互利互惠，价值共振。
        </div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.xcgf"
          :key="`politicalparty-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span
            ><strong>{{ item.item }}</strong
            >{{ item.text }}</span
          >
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="防返贫监测帮扶平台"
      name="2"
      class="politicalparty-item"
      :class="{ 'politicalparty-item-check': activeName == '2' }"
    >
      <div class="info">
        以<strong>算法模型</strong>为核心的大数据防返贫动态监测治理体系，辅助健全防返贫帮扶工作机制，实现<strong>精准监测、精准认定、精准帮扶、精准管理</strong>。在切实巩固脱贫攻坚成果的同时，为巩固拓展脱贫攻坚成果过渡期后政策帮扶提供科学决策依据
      </div>
      <img
        :src="product_society_society_ffpjcbf"
        alt="防返贫监测帮扶平台"
        class="politicalparty-img"
      />
    </van-collapse-item>
    <van-collapse-item
      title="经济聚力数字平台"
      name="3"
      class="politicalparty-item"
      :class="{ 'politicalparty-item-check': activeName == '3' }"
    >
      <div class="info">
        通过经济聚力数字平台，构建面向农业农村的综合信息服务体系，建立涉农信息普惠服务机制，推动乡村管理服务数字化，从而提升乡村经济服务能力，探索乡村振兴新模式。
      </div>
      <img
        :src="product_society_society_jjjl"
        alt="经济聚力数字平台"
        class="politicalparty-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.jjjl"
          :key="`politicalparty-item3-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_society_xzzjyy from "@/../static/img/product/product_society_society_xzzjyy.png";
import product_society_society_ffpjcbf from "@/../static/img/product/product_society_society_ffpjcbf.png";
import product_society_society_jjjl from "@/../static/img/product/product_society_society_jjjl.png";
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
export default {
  data() {
    return {
      product_society_society_xzzjyy,
      product_society_society_ffpjcbf,
      product_society_society_jjjl,
      product_society_superiority,
      activeName: "",
      advantageList: {
        xcgf: [
          {
            item: "农民致富：",
            text: "平台帮助农民致富-农民解决拖欠"
          },
          {
            item: "网点增收：",
            text: "为网点带来新流量-网点成为综合服务点"
          },
          {
            item: "平台共赢：",
            text: "平台共赢：给网点带来了新流量–网点赋予了平台新抓手"
          }
        ],
        jjjl: [
          "镇域资源一屏汇集，村镇资源详细陈列",
          "政企交流一网统揽，齐手协力共谋发展",
          "干部考核同步进行，乡村振兴高效有力"
        ]
      }
    };
  }
};
</script>
<style lang="less" scoped>
.politicalparty {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .politicalparty-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }
  .politicalparty-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .politicalparty-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    .title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .text {
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin-bottom: 32px;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin-bottom: 32px;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/society/economicDevelopment.vue